import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { ButtonType } from 'wix-rich-content-common';
import { PluginToolbarButtons } from '../../../enums';
import { Modals } from '../modals';
import { Edit, GalleryTorpedo, GalleryGrid, Settings, Refresh } from '../../../components/icons';
const defaultButtons = [
    PluginToolbarButtons.BEST_FIT,
    PluginToolbarButtons.FULL_WIDTH,
    PluginToolbarButtons.LAYOUT_GRID,
    PluginToolbarButtons.LAYOUT_MASONRY,
    PluginToolbarButtons.SEPARATOR,
    PluginToolbarButtons.REPLACE,
    PluginToolbarButtons.DELETE
];
const configurableButtons = {
    [PluginToolbarButtons.BEST_FIT]: {
        keyName: 'sizeContent',
        type: ButtonType.SIZE_CONTENT,
        mobile: false
    },
    [PluginToolbarButtons.FULL_WIDTH]: {
        keyName: 'sizeFullWidth',
        type: ButtonType.SIZE_FULL_WIDTH,
        mobile: false
    },
    [PluginToolbarButtons.LAYOUT_GRID]: {
        keyName: 'layoutGrid',
        type: ButtonType.TOGGLE,
        icon: GalleryGrid,
        mobile: true,
        onClick: (store)=>{
            const data = store.get('componentData') || {};
            store.update('componentData', _object_spread_props(_object_spread({}, data), {
                styles: _object_spread_props(_object_spread({}, data.styles), {
                    galleryLayout: 2
                })
            }));
        },
        tooltipTextKey: 'GalleryPlugin_Layout_Grid'
    },
    [PluginToolbarButtons.LAYOUT_MASONRY]: {
        keyName: 'layoutMasonry',
        type: ButtonType.TOGGLE,
        icon: GalleryTorpedo,
        mobile: true,
        onClick: (store)=>{
            const data = store.get('componentData') || {};
            store.update('componentData', _object_spread_props(_object_spread({}, data), {
                styles: _object_spread_props(_object_spread({}, data.styles), {
                    galleryLayout: 1
                })
            }));
        },
        tooltipTextKey: 'GalleryPlugin_Layout_Masonry'
    },
    [PluginToolbarButtons.SEPARATOR]: {
        keyName: 'separator',
        type: ButtonType.SEPARATOR,
        mobile: false
    },
    [PluginToolbarButtons.REPLACE]: {
        keyName: 'add',
        type: 'file',
        icon: Edit,
        mobile: false,
        multiple: true,
        tooltipTextKey: 'GalleryImageSettings_Replace_Label'
    },
    [PluginToolbarButtons.SETTINGS]: {
        keyName: 'advanced_settings',
        type: ButtonType.EXTERNAL_MODAL,
        icon: Settings,
        modalName: Modals.GALLERY_SETTINGS,
        asPanel: true,
        mobile: false,
        tooltipTextKey: 'SettingsButton_Tooltip'
    },
    [PluginToolbarButtons.DELETE]: {
        keyName: 'delete',
        type: ButtonType.DELETE,
        mobile: true
    },
    [PluginToolbarButtons.REFRESH]: {
        keyName: 'refresh',
        type: ButtonType.CUSTOM,
        icon: Refresh,
        onClick: async (helpers, store)=>{
            const currentData = store.get('componentData');
            if (!currentData || !currentData.data || !Array.isArray(currentData.data) || !helpers.fetchFreshDeviationData) {
                alert('Failed to get data for the update');
                return;
            }
            const deviationIds = currentData.data.map((d)=>d.deviationId);
            if (deviationIds.length > 24) {
                alert(`The maximum number of deviations we can refresh is 24, your gallery contains ${deviationIds.length}.`);
                return;
            }
            try {
                const freshData = await helpers.fetchFreshDeviationData(currentData.data);
                store.set('componentData', _object_spread_props(_object_spread({}, currentData), {
                    data: freshData
                }));
            } catch (e) {
                alert('Failed to fetch updated deviation data');
            }
        },
        mobile: true,
        tooltipTextKey: 'editor.galleryPlugin.refresh.tooltip'
    }
};
export default (({ pluginConfig, helpers, t })=>{
    const buttons = pluginConfig.toolbarButtons || defaultButtons;
    // If we only have one button toggle remove it
    const hasGrid = buttons.find((b)=>b === PluginToolbarButtons.LAYOUT_GRID) !== undefined;
    const hasMason = buttons.find((b)=>b === PluginToolbarButtons.LAYOUT_MASONRY) !== undefined;
    let hasFullWidth = buttons.find((b)=>b === PluginToolbarButtons.FULL_WIDTH) !== undefined;
    const hasBestFit = buttons.find((b)=>b === PluginToolbarButtons.BEST_FIT) !== undefined;
    const remove = {};
    if (!hasMason && hasGrid) {
        remove[PluginToolbarButtons.LAYOUT_GRID] = true;
    }
    if (hasMason && !hasGrid) {
        remove[PluginToolbarButtons.LAYOUT_MASONRY] = true;
    }
    if (hasFullWidth && !hasBestFit) {
        remove[PluginToolbarButtons.FULL_WIDTH] = true;
        hasFullWidth = false;
    }
    if (!hasFullWidth && hasBestFit) {
        remove[PluginToolbarButtons.BEST_FIT] = true;
    }
    return buttons.filter((button)=>!!configurableButtons[button]).filter((button)=>remove[button] ? false : true).filter((button, idx)=>idx === 0 && button === PluginToolbarButtons.SEPARATOR ? false : true).map((button)=>{
        const configButton = configurableButtons[button];
        if (button === PluginToolbarButtons.REFRESH && !configButton.isBound) {
            configButton.onClick = configButton.onClick.bind(configButton, helpers);
            configButton.isBound = true;
        }
        return configButton;
    }).map((button)=>_object_spread_props(_object_spread({}, button), {
            t
        }));
});
